import { Timestamp } from '@klear/time'

export type UserLegalAgreementAcceptanceIdentity = { kind: 'new' } | { kind: 'saved'; id: number }

export type UserLegalAgreementAcceptanceJson = {
  identity: UserLegalAgreementAcceptanceIdentity
  legalAgreementId: number
  userId: number
  ipAddress: string
  signature?: string
  userAgent?: string
  consentText?: string
  consentVersionId?: string
  consentEvent?: string
  presentedDocumentUrl?: string
  signingSessionId?: number
  createdAt?: number | Timestamp
}

export function userLegalAgreementAcceptanceToJson(acceptance: UserLegalAgreementAcceptance) {
  return {
    identity: acceptance.identity,
    legalAgreementId: acceptance.legalAgreementId,
    userId: acceptance.userId,
    ipAddress: acceptance.ipAddress,
    signature: acceptance.signature,
    userAgent: acceptance.userAgent,
    consentText: acceptance.consentText,
    consentVersionId: acceptance.consentVersionId,
    consentEvent: acceptance.consentEvent,
    presentedDocumentUrl: acceptance.presentedDocumentUrl,
    signingSessionId: acceptance.signingSessionId,
    createdAt: acceptance.createdAt?.epochMs
  }
}

export class UserLegalAgreementAcceptance {
  static readonly __klearClass = 'UserLegalAgreementAcceptance'

  readonly identity: UserLegalAgreementAcceptanceIdentity
  legalAgreementId: number
  userId: number
  ipAddress: string
  signature?: string
  userAgent?: string
  consentText?: string
  consentVersionId?: string
  consentEvent?: string
  presentedDocumentUrl?: string
  signingSessionId?: number
  createdAt?: Timestamp

  constructor(props: UserLegalAgreementAcceptanceJson) {
    this.identity = props.identity?.kind === 'saved' ? { kind: 'saved', id: props.identity.id } : { kind: 'new' }
    this.legalAgreementId = props.legalAgreementId
    this.userId = props.userId
    this.ipAddress = props.ipAddress
    this.signature = props.signature
    this.userAgent = props.userAgent
    this.consentText = props.consentText
    this.consentVersionId = props.consentVersionId
    this.consentEvent = props.consentEvent
    this.presentedDocumentUrl = props.presentedDocumentUrl
    this.signingSessionId = props.signingSessionId
    this.createdAt = props.createdAt != null ? new Timestamp(props.createdAt) : undefined
    this.assertValid()
  }

  get id(): number | undefined {
    return this.identity.kind === 'saved' ? this.identity.id : undefined
  }

  assertValid(): void {
    if (!this.legalAgreementId) {
      throw new Error('UserLegalAgreementAcceptance legalAgreementId is required')
    }
    if (!this.userId) {
      throw new Error('UserLegalAgreementAcceptance userId is required')
    }
  }

  toJSON() {
    return userLegalAgreementAcceptanceToJson(this)
  }
}
